import getMimeType from './getMimeType';

export default function isPSD(file: File) {
  return getMimeType(file).subType === 'psd';
}
